// extracted by mini-css-extract-plugin
module.exports = {"Spinner":"Spinner_Spinner__nPh9v","lds-dual-ring":"Spinner_lds-dual-ring__2oQH6"};